import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { NamedSoftwareVersion } from "./NamedSoftwareVersion";

export class SoftwareFilter {
    updateType: UpdateTypeEnum = UpdateTypeEnum.Unknown;
    versionsList: NamedSoftwareVersion[] = [];

    constructor(updateType: any) {
        this.updateType = updateType;
    }
}
